// src/models/vendas/Nota.js

import FormaPag from "../financeiro/FormaPag.js";
import { Cliente } from "../pessoas/Cliente.js";
import { NotaItem } from "./NotaItem"; // ajuste o caminho conforme necessÃ¡rio


export class Nota {
  constructor() {
    this.id = 0;
    this.filialId = 0;
    this.clienteId = null;
    this.clienteNome = null;
    this.cpf = null;
    this.cnpj = null;
    this.fornecedorId = null;
    this.ordemServicoId = null;
    this.ordensServicoIds = [];
    this.naturezaId = null;
    this.formaPagId = null;
    this.caixaId = null;
    this.usuarioId = null;
    this.serie = null;
    this.numDoc = null;
    this.chave = null;
    this.modeloNF = null;
    this.cfop = '';
    this.tipoMov = null;
    this.vProd = 0;
    this.vDesc = 0;
    this.vOutro = 0;
    this.vFrete = 0;
    this.vNota = 0;
    this.dataLanc = null;
    this.dataEmissao = null;
    this.filial = null;
    this.cliente = new Cliente();
    this.fornecedor = null;
    this.natureza = null;
    this.formaPag = new FormaPag();
    this.caixa = null;
    this.usuario = null;
    this.qrCode = null;
    this.qrCodeBase64 = null;
    this.observacao = null;
    this.notaItens = [new NotaItem()];
  }
}

